import {
  Component,
  OnInit,
  Input,
  OnChanges,
  ViewChild,
  ElementRef,
  HostListener,
  OnDestroy
} from "@angular/core";
import * as d3 from "d3";
import { SharedUtils } from "../../../../../../shared/shared.utils";
import { SessionStateService } from "../../../../../../core/services/session-state.service";
import { DevicesService } from "../../../../../devices/devices.service";
import { EnergyService } from "../../../../../energy/energy.service";
import { Power1, Bounce, Linear } from "gsap/all";
import { LoadingModule, ANIMATION_TYPES } from "ngx-loading";
declare var TweenMax: any;
@Component({
  selector: "app-consumption-flow",
  templateUrl: "./consumption-flow.component.html",
  styleUrls: ["./consumption-flow.component.scss"]
})
// <img id='batteryStorage' [src]='getBatteryIcon(chargePercentage)' *ngIf="hasStorage && batteryLoaded">
export class ConsumptionFlowComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  gridConsumption;
  @Input()
  consumptionSmartMeterIsOnline: boolean;

  // *D3 *//
  hostElement: any;
  path: any;
  svg: any;

  flowAnimation;
  totalConsumption = null;
  marker;
  SharedUtils = SharedUtils;

  consumptionLoadingAnimationConfig = {
    animationType: ANIMATION_TYPES.circleSwish,
    backdropBackgroundColour: "rgba(0, 0, 0, 0)"
  };

  loadingConsumption: boolean = false;

  constructor(
    private devicesService: DevicesService,
    private energyService: EnergyService,
    public sessionStateService: SessionStateService
  ) {}

  // In order to fix memory issues ==> When screen is not being shown animation should be stopped
  @HostListener('document:visibilitychange')
  onVisibilityChange() {
    if(document.hidden) {
      this.stopAnimation();
    } else {
      this.startAnimation();
    }
  }

  ngOnInit() {
    this.createAnimation();
  }

  ngOnChanges() {
    this.totalConsumption = this.gridConsumption;

    // Consumption Offline
    if (this.consumptionSmartMeterIsOnline === false) {
      $("#consumptionOfflineContainer").css("display", "block");
    }
  }

  getHouseGridIcon() {
    if (this.gridConsumption > 0) {
      return "/assets/img/icons/flow-house-grid.svg";
    } else {
      return "/assets/img/icons/flow-house-none.svg";
    }
  }

  createAnimation() {
    this.svg = d3
      .select("#lineChart")
      // .attr("display", "block")
      .attr("width", 650)
      .attr("height", "100%");

    const lineHeight =
      document.getElementById("lineContainer").offsetHeight - 6; //Subtract strokeWidth

    const line = d3.line()([
      [580, lineHeight],
      [80, lineHeight]
    ]);

    this.path = this.svg
      .append("path")
      .attr("d", line)
      .attr("stroke-width", "3")
      .attr("fill", "#FBFBFB")
      .attr("stroke", "#fb6059");

    this.startAnimation();
  }

  startAnimation() {
    this.flowAnimation = setInterval(() => {
      const line = this.svg.select("path").attr("d");
      if (this.totalConsumption > 0) {
        this.marker = this.svg.append("circle");
        const startPointDown = this.pathStartPoint(line);
        this.marker
          .attr("r", 3)
          .attr("transform", "translate(" + startPointDown + ")")
          .attr("fill", "#fb6059")
          .transition()
          .duration(4000)
          .attrTween("transform", this.translateAlong(this.path.node()))
          .on("end", function() {
            d3.select(this).remove();
          });
      }
    }, 500);
  }

  stopAnimation() {
    if(this.flowAnimation) {
      clearInterval(this.flowAnimation);
    }
    this.svg.selectAll('circle').remove();
  }

  pathStartPoint(line) {
    const d = this.path.attr("d"),
      dsplitted = line.split("");
    return dsplitted[1].split(",");
  }

  translateAlong(path) {
    const l = path.getTotalLength();
    return function(i) {
      return function(t) {
        const p = path.getPointAtLength(t * l);
        return "translate(" + p.x + "," + p.y + ")";
      };
    };
  }

  ngOnDestroy(): void {
    // if (this.flowAnimation) {
    //   clearInterval(this.flowAnimation);
    // }
    this.stopAnimation();
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/home/home-tab/home-flows-view/flows/consumption-flow/consumption-flow.component.ts